/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeoJsonDataModelApiModel } from '../../models/geo-json-data-model-api-model';

export interface GetAllStateBoundries$Params {
}

export function getAllStateBoundries(http: HttpClient, rootUrl: string, params?: GetAllStateBoundries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeoJsonDataModelApiModel>>> {
  const rb = new RequestBuilder(rootUrl, getAllStateBoundries.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeoJsonDataModelApiModel>>;
    })
  );
}

getAllStateBoundries.PATH = '/v1/lookup/boundries';
